import { Component, computed, effect, inject, signal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';

import { Router } from '@angular/router';
import { IBook, IBookSortFilterSet, IBookList, BookSortFilterSet } from 'src/app/_models';
import { AuthService, LogService } from 'src/app/services';
import { BookService } from 'src/app/services/book.service';

import { FilterSortComponent } from '../filter-sort/filter-sort.component';
import { BooksHeaderComponent } from '../books-header/books-header.component';
import { BooksGridComponent } from '../books-grid/books-grid.component';
import { LoadingService } from 'src/app/services/loading.service';
import { LoadingComponent } from '../loading/loading.component';
import { FilterSortService } from 'src/app/services/filter-sort.service';
import { BooksListComponent } from '../books-list/books-list.component';
import { Status } from 'src/app/_models/status.model';
import { P } from '@angular/cdk/keycodes';


@Component({
  selector: 'kbm-books-home',
  templateUrl: './books-home.component.html',

  styleUrls: ['./books-home.component.scss'],
  standalone: true,
  imports: [
    MatSidenavModule,
    MatButtonModule,
    MatDialogModule,
    FilterSortComponent,
    BooksHeaderComponent,
    BooksGridComponent,
    BooksListComponent,
    LoadingComponent,
  ],
  providers: [
    FilterSortService,
  ]
})
export class BooksHomeComponent {

  bookService = inject(BookService);
  authService = inject(AuthService);
  filterSortService = inject(FilterSortService);
  dialog = inject(MatDialog);
  router = inject(Router);
  loadingService = inject(LoadingService);
  logService = inject(LogService);


  #bookList = signal<IBookList>({
    bookCount: 0,
    books: []
  });

  setCount = computed(() => {
    return this.filteredList().length;
  });

  sortFilterSet = signal(new BookSortFilterSet({}));

  totalBookCount = computed(() => {
    const bookList = this.#bookList();
    return bookList.bookCount;
  });

  status = signal<Status>({
    isFilterSortOpen: false,
    isGridLayout: true,
    pageIndex: 0,
    pageSize: 10,
    startingIdx: 0,
    endingIdx: 10,
  });

  filteredList = computed(() => {
    const bookList = this.#bookList().books;
    const filteredList = this.applySortFilter(bookList, this.sortFilterSet());
    return filteredList;
  });

  books = computed(() => {
    const bookList = this.filteredList();
    const pagedList = this.applyPaging(bookList, this.status().startingIdx, this.status().endingIdx);
    return pagedList;
  });

  isLoggedIn = computed(() => this.authService.isLoggedIn());


  constructor() {

    this.loadBookList();
    effect(() => {
      // check sortFilterSet for page reset changes
      //  sessionStorage.setItem('SortFilterSettings', JSON.stringify(currentSet));
    }
    );

  }

  ngOnInit() {

    const currentSet = sessionStorage.getItem('SortFilterSettings');
    if (currentSet && JSON.parse(currentSet) !== null) {
      this.sortFilterSet.update(() => JSON.parse(currentSet))
    }

  }

  ngAfterViewInit() {
    this.status.update((prev) => {
      return {
        ...prev,
        pageSize: this.status().pageSize,
        pageIndex: this.status().pageIndex,
        startingIdx: this.status().startingIdx,
        endingIdx: this.status().endingIdx
      }
    });

  }

  async loadBookList() {
    try {
      this.loadingService.loadingOn();
      const bookList = await this.bookService.getBookList();
      this.#bookList.set(bookList);
      // this.displayedBooks.set(this.#bookList().books.slice(0, 10));

    }
    catch (err) {
      this.logService.error(JSON.stringify(err));
      console.log(err);
    }
    finally {
      this.loadingService.loadingOff();
    }
  }

  applySortFilter(bookList: IBook[], filterSet: IBookSortFilterSet): IBook[] {
    return this.filterSortService.sortFilterList(bookList, filterSet)
  }

  applyPaging(inList: IBook[], startIdx: number, endIdx: number): IBook[] {
    return inList.slice(startIdx, endIdx);

  }

  toggleLayout($event: any) {
    this.status.update((prev) => {
      return {
        ...prev,
        isGridLayout: $event
      }
    })
  }

  toggleFilterSort() {
    this.status.update((prev) => {
      return {
        ...prev,
        isFilterSortOpen: !prev.isFilterSortOpen
      }
    })
  }

  onPageChange($event: any) {
    this.status.update((prev) => {
      return {
        ...prev,
        pageSize: $event.pageSize,
        pageIndex: $event.pageIndex,
        startingIdx: $event.pageIndex * $event.pageSize,
        endingIdx: (($event.pageIndex + 1) * $event.pageSize > $event.length) ? $event.length
          : ($event.pageIndex + 1) * $event.pageSize
      }
    });
  }

  resetPage() {
    if (this.status().pageIndex !== 0) {
      this.status.update((prev) => {
        return {
          ...prev,
          pageIndex: 0,
          startingIdx: 0,
          endingIdx: prev.pageSize
        }
      });
    }
  }

}
